import { Link } from "react-router-dom";
import type { WorkItem } from "@/mocks/works";

export default function WorkCard({ work }: { work: WorkItem }) {
  return (
    <Link
      to={`/works/${work.id}`}
      data-product-shop
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/80 hover:border-primary-300 transition-all cursor-pointer"
    >
      <div className="relative w-full aspect-[4/5] overflow-hidden">
        <img
          src={work.cover}
          alt={work.title}
          title={`${work.title} - 芒果传媒案例展示`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-foreground-950/70 text-background-50 text-xs font-medium backdrop-blur-sm">
          {work.type}
        </span>
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center justify-between gap-2">
          <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 group-hover:text-primary-700 transition-colors">
            {work.title}
          </h3>
          <span className="text-xs text-foreground-500 shrink-0">{work.year}</span>
        </div>
        <p className="text-sm text-foreground-600 mt-2 leading-relaxed line-clamp-2">
          {work.summary}
        </p>
      </div>
    </Link>
  );
}